export default "__VITE_ASSET__BAgVIqZd__"